var map = {
	"./buhler.png": 2995,
	"./helvetia.png": 8008,
	"./kantonsspital-right.png": 2842,
	"./leica.png": 8665,
	"./logistic_zentrum.png": 3793,
	"./mobiliar.png": 9578,
	"./omega.png": 3058,
	"./post-finance.png": 793,
	"./rolex.png": 9172,
	"./undefined.png": 5010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;